import { render } from "./SalarySlip.vue?vue&type=template&id=d2aa89f4"
import script from "./SalarySlip.vue?vue&type=script&lang=js"
export * from "./SalarySlip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__